export const UTM_PARAMETER_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"] as const;

type UtmParameters = Partial<Record<(typeof UTM_PARAMETER_KEYS)[number], string>>;

const STORAGE_KEY = "wl-utm-parameters";

function isUtmParameters(value: unknown): value is UtmParameters {
    return typeof value === "object" && value !== null && !Array.isArray(value) && Object.values(value).every(entry => typeof entry === "string");
}

export function captureUtmParameters(search: string) {
    const searchParams = new URLSearchParams(search);
    const parameters: UtmParameters = {};

    for (const key of UTM_PARAMETER_KEYS) {
        const value = searchParams.get(key);

        if (value) {
            parameters[key] = value;
        }
    }

    if (Object.keys(parameters).length === 0) {
        return;
    }

    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(parameters));
    } catch {}
}

export function takeUtmParameters(): UtmParameters | undefined {
    let stored: string | null = null;

    try {
        stored = sessionStorage.getItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {}

    if (!stored) {
        return undefined;
    }

    try {
        const parsed: unknown = JSON.parse(stored);

        return isUtmParameters(parsed) ? parsed : undefined;
    } catch {
        return undefined;
    }
}
